import React from 'react'
import { Row, Column } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import './slide-show.scss'
import Iconfont from '@/components/iconfont/iconfont'
import classNames from 'classnames'
import { showLayer, layerManage } from '@/utils/layer'
import { ChooseMaterialDialog } from '@/views/main/modules/goods-manage/components/material-library/choose-material-dialog'
import { getQiniuImgUrl } from '@/config/qiniu'
import { Image } from 'antd'
import { useFormikContext, FieldArray } from 'formik'
import { IDetailForm } from '../detail-form/detail-form'

export const SlideShow = () => {
    const cls = (...args: string[]) => getBEMCls('slideshow', ...args)
    const { values } = useFormikContext<IDetailForm>()

    return (
        <Row className={cls()}>
            <div
                data-margin-right-7
                data-color-000
                data-font-size-14
                data-font-weight-500
                data-margin-top-12
                data-margin-left-20
            >
                顶部轮播图
            </div>
            <FieldArray name="mall_goods_images">
                {imageHlper => (
                    <>
                        {values.mall_goods_images.map((item, index) => (
                            <div className={cls('item')} key={item.img_url}>
                                <Image src={getQiniuImgUrl(item.img_url)} width={60} height={60} />
                                {index !== 0 && (
                                    <div
                                        className={cls('item', 'delete')}
                                        onClick={e => {
                                            e.stopPropagation()
                                            imageHlper.remove(index)
                                        }}
                                    >
                                        <Iconfont name="icon3shanchu-20" size={18}></Iconfont>
                                    </div>
                                )}
                                {index === 0 ? (
                                    <div
                                        onClick={e => {
                                            e.stopPropagation()
                                            showLayer(
                                                <ChooseMaterialDialog
                                                    onSelected={data => {
                                                        if (index === 0) {
                                                            imageHlper.replace(index, {
                                                                id: 0,
                                                                img_url: data.url,
                                                            })
                                                        }
                                                        layerManage.pop()
                                                    }}
                                                />,
                                            )
                                        }}
                                        className={cls('item', 'change')}
                                    >
                                        更换封面
                                    </div>
                                ) : (
                                    <div
                                        onClick={e => {
                                            e.stopPropagation()
                                        }}
                                        className={cls('item', 'replace')}
                                    >
                                        <i
                                            className="icon6zuodanjiantou-16 iconfont"
                                            onClick={() => {
                                                imageHlper.move(index, index - 1)
                                            }}
                                        />
                                        <i
                                            className="icon6youdanjiantou-16 iconfont"
                                            onClick={() => {
                                                if (index === values.mall_goods_images.length - 1) return
                                                imageHlper.move(index, index + 1)
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        ))}

                        {values.mall_goods_images.length < 5 && (
                            <Column
                                className={classNames(cls('item'), cls('upload'))}
                                onClick={() => {
                                    showLayer(
                                        <ChooseMaterialDialog
                                            onSelected={data => {
                                                imageHlper.push({
                                                    id: 0,
                                                    img_url: data.url,
                                                })
                                                layerManage.pop()
                                            }}
                                        />,
                                    )
                                }}
                            >
                                <Iconfont name="icon6shangchuan-24" size={20}></Iconfont>
                                <div data-font-size-12 data-color-999 data-margin-top-6>
                                    素材库
                                </div>
                            </Column>
                        )}
                    </>
                )}
            </FieldArray>
        </Row>
    )
}
